module.exports = __webpack_public_path__ + "bf22dbe5c5ab0f0d2cc7a778c1dcc974.png";